/* Template: Fit vid
   ========================================================================== */

template.component.fitvids = function() {

	$('.video-container').fitVids();

};
